module.exports = __webpack_public_path__ + "static/media/amusement(15).7c06e3df.PNG";